<template>

    <div>

        <transition-group name="slide-fade" tag="div" class="grid-testimonials-video" v-if="selectedCategory == 'video'">

            <div
                    v-for="(post, index) in posts"
                    :key="index + 10"
                    class="item item-video"
                    :class="['item-' + ++index]"
            >

                <!-- Testimonial Video-->
                <div class="post-inner post-testimonial-video">

                    <b-button v-b-modal="`bv-modal-${index}`" class="btn-video-modal">
                        <img class="video_thumbnail" :src="post.acf.thumbnail" alt="thumbnail">

                        <span class="play-icon" v-html="play">
                        </span>

                    </b-button>

                    <div class="post-title">{{ post.acf.description }}</div>

                    <b-modal :id="`bv-modal-${index}`" hide-footer modal-class="modal-testimonial-video">
                        <template v-slot:modal-title>
                            <div class="post-modal-title">
                                <h3>{{ post.post_title }}</h3>
                            </div>
                        </template>
                        <div class="d-block text-center">
                            <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + post.acf.video_id + '?rel=0&showinfo=&autoplay=1&mute=1'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </b-modal>

                </div>

            </div>

        </transition-group>
    </div>

</template>

<script>

    export default {
        props: {
            posts: {
                type: Array
            },
            selectedCategory: {
                type: String
            }
        },
        data: function () {
            return {
                play: `<?xml version="1.0" encoding="UTF-8"?>
<svg width="60px" height="60px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 59.1 (86144) - https://sketch.com -->
    <title>Group 3</title>
    <desc>Created with Sketch.</desc>
    <g id="Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Home" transform="translate(-352.000000, -3371.000000)">
            <g id="Group-3" transform="translate(352.000000, 3371.000000)">
                <g id="Group-12" fill="#00469E" opacity="0.804966518">
                    <circle id="Oval" cx="30" cy="30" r="30"></circle>
                </g>
                <polygon id="Path-6" fill="#FFFFFF" points="24 19 39 29.8597829 24.7501465 40.1764706"></polygon>
            </g>
        </g>
    </g>
</svg>`
            }
        },
        created: function () {
        },
        updated: function () {

            this.$nextTick(function () {
                // Code that will run only after the
                // entire view has been re-rendered

                if (jQuery('.grid-testimonials-video .item').length > 0) {
                    jQuery('.grid-testimonials-video .post-title').matchHeight();
                }

            })
        }
    }
</script>

<style lang="scss">

    .modal-testimonial-video {

        .modal-body {
            padding-top: 20px;
        }

    }

    .control {
        width: 200px;
        height: 100px;
        border: 6px solid #333;
        position: relative;
        display: flex;
    }

    .slide-fade-enter-active {
        transition: all 0.0s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.0s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
        transition: all 0.0s ease;
    }

</style>